<template>
  <v-row v-if="config.settings">
    <v-col cols="12"><h3>SETTING</h3></v-col>
    <v-col cols="12">
      <v-divider></v-divider>
    </v-col>
    <v-col cols="12">
      <h4>CONTENT</h4>
    </v-col>

    <v-col cols="12">
      <label class="d-inline-block" for="">Sub Title</label>
      <v-text-field
        hide-details
        height="auto"
        v-model="config.settings.subTitle"
        @input="$parent.changeConfig"
      ></v-text-field>
    </v-col>

    <v-col cols="12">
      <label class="d-inline-block" for="">Title</label>
      <v-text-field
        hide-details
        height="auto"
        v-model="config.settings.title"
        @input="$parent.changeConfig"
      ></v-text-field>
    </v-col>

    <v-col cols="12">
      <label class="d-inline-block" for="">Description</label>
      <v-textarea
        hide-details
        height="auto"
        rows="3"
        v-model="config.settings.description"
        @input="$parent.changeConfig"
      ></v-textarea>
    </v-col>

    <v-col cols="12">
      <label class="d-inline-block mb-1" for="">Image</label>
      <UploadOneImage :itemSetData="config.settings" :image="{ src: config.settings.image }" @callback="getImage" />
    </v-col>

    <v-col cols="12">
      <label class="d-inline-block" for="">Button Label</label>
      <v-text-field
        hide-details
        height="auto"
        v-model="config.settings.buttonLabel"
        @input="$parent.changeConfig"
      ></v-text-field>
    </v-col>

    <v-col cols="12">
      <label class="d-inline-block" for="">Button Link</label>
      <v-select
        hide-details
        v-model="config.settings.url"
        :items="pageOptions"
        item-text="label"
        item-value="value"
        :loading="isLoading"
        @change="$parent.changeConfig"
      ></v-select>
    </v-col>

    <v-col cols="12" class="mt-2">
      <v-btn small outlined @click="callbackRemoveSection(configSection)">Remove Section</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import storeRequest from '../../../../../apis/request/storeRequest';

export default {
  name: 'PageBanner',
  components: {},
  props: {
    callbackRemoveContent: {
      type: Function,
      default: () => {},
    },
    configSection: {
      type: Object,
      default: () => {},
    },
    callbackAddContent: {
      type: Function,
      default: () => {},
    },
    callbackRemoveSection: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      config: {},
      pages: [],
      isLoading: false,
    };
  },
  computed: {
    pageOptions() {
      return this.pages.map(page => ({
        label: page.title,
        value: `/pages/${page.handle}`,
      }));
    },
  },
  created() {
    this.config = this.configSection;
    this.getPages();
  },
  methods: {
    getImage(images, item) {
      item.image = images.src;
      this.$parent.changeConfig();
    },
    async getPages() {
      this.isLoading = true;
      try {
        const res = await storeRequest.get('/stores/onlinestore/pages', {
          params: { page: 1, limit: 1000 },
        });
        this.pages = res.data.pages;
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
